<template>
  <el-dialog :visible="show" title="VR素材管理" append-to-body @close="$emit('update:show', false)" width="720px" :close-on-click-modal="false">
    <el-tabs v-model="tabActive" type="card">
      <el-tab-pane label="素材库" name="tab1">
        <div class="preview-lists-box" v-loading="loadingLists">
          <div class="preview-lists-header">
            <div class="left v-row v-row-align-center">
              <el-checkbox v-model="checkAll" @change="changeCheckAll"><span class="v-font-12">全选</span></el-checkbox>
              <el-button size="min" class="v-ml-10" @click="batchDeleteMedia" :disabled="lists.filter((item) => item.active).length == 0">删除</el-button>
            </div>
            <div class="right v-row v-row-align-center">
              <el-input size="small" v-model="keyword" placeholder="请输入文件名称"></el-input>
              <el-button size="mini" type="primary" class="v-ml-5" @click="getList(1)">搜索</el-button>
            </div>
          </div>

          <!-- 资源列表 -->
          <div v-if="lists.length" class="preview-lists">
            <div v-for="item in lists" :key="item.id" class="preview-item" :class="{ active: item.active }">
              <div class="preview-box">
                <img @click="toggleActive(item)" class="preview" :src="item.key_preview" />
                <i v-if="item.active" class="iconfont icon-right right"></i>
              </div>

              <!-- 标题、分类、查看、修改、删除  -->
              <div class="preview-footer">
                <el-checkbox v-model="item.active"></el-checkbox>
                <div class="name v-ml-5" @click="toggleActive(item)">
                  <div class="txt v-ellipsis">{{ item.name }}</div>
                </div>
                <div class="operate">
                  <a class="operate-btn" :href="item.key_preview" target="_blank"><i class="el-icon-zoom-in"></i></a>
                  <i @click="editName(item)" class="operate-btn el-icon-edit v-mr-10 v-ml-10"></i>
                  <el-popconfirm title="确认删除?" @onConfirm="deleteMedia(item)">
                    <i slot="reference" class="operate-btn el-icon-delete"></i>
                  </el-popconfirm>
                </div>
              </div>
            </div>
          </div>

          <el-pagination
            v-if="lists.length > 0"
            layout="total,sizes,prev, pager, next"
            @size-change="
              (page_size) => {
                getList(page, page_size);
              }
            "
            @current-change="
              (page) => {
                getList(page);
              }
            "
            :current-page.sync="page"
            :total="total"
          ></el-pagination>

          <div class="placeholder v-row v-row-center" v-if="lists.length == 0" v-loading="loadingUpload">
            <div>暂无资源数据</div>
            <el-button v-if="method != 'onlySource'" type="text" @click="tabActive = 'tab2'">手动上传</el-button>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane v-if="method != 'onlySource'" label="手动上传" name="tab2">
        <div class="preview-lists">
          <div v-for="(item, index) in uploadedLists" :key="item.key" class="preview-item upload" :class="{ active: item.active }">
            <div @click="toggleActive(item)" class="preview-box">
              <template v-if="item.preview">
                <img class="preview" :src="item.preview" />
                <i v-if="item.active" class="iconfont icon-right right"></i>
              </template>
              <div class="preview-txt" v-if="item.status == 2">
                <div class="progress">{{ item.percent }}</div>
              </div>
              <div class="preview-txt" v-if="item.status == 3">等待上传</div>
              <div class="preview-txt" v-if="item.status == 4">
                {{ item.errMsg }}
              </div>
            </div>
            <!-- 标题、分类、查看、修改、删除 -->
            <div class="preview-footer">
              <template v-if="item.status == 1">
                <el-checkbox v-model="item.active"></el-checkbox>
                <div class="name v-ml-5" @click="toggleActive(item)">
                  <div class="txt v-ellipsis">{{ item.name }}</div>
                </div>
                <div class="operate">
                  <a class="operate-btn v-mr-10" :href="item.preview" target="_blank"><i class="el-icon-zoom-in"></i></a>
                  <el-popconfirm title="确认删除?" @onConfirm="uploadedLists.splice(index, 1)">
                    <i slot="reference" class="operate-btn el-icon-delete"></i>
                  </el-popconfirm>
                </div>
              </template>
            </div>
          </div>

          <div v-if="uploadedLists.length < 100" class="upload-btn-box">
            <div @click="chooseFile" class="upload-btn v-col v-center" v-loading="loadingUpload">
              <i class="icon el-icon-plus"></i>
            </div>
            <div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px，单次最多上传100张,100M以内</div>
          </div>
        </div>
        <input ref="fileInput" hidden class="file" type="file" multiple accept="image/*" />
      </el-tab-pane>
    </el-tabs>

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" size="small" :disabled="mode == 2">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['show', 'method', 'select_ids'],

  data() {
    return {
      title: '',
      loading: false,
      image: null,
      category: [],
      media_category_id: -1,
      lists: [],
      page: 1,
      page_size: 10,
      total: 0,
      keyword: '',
      loadingLists: false,
      loadingUpload: false,
      loadingMoving: false,
      isShowCategoryList: false,
      rows: null,
      checkAll: false, //全选
      mode: 1, //1正常 2编辑
      tabActive: 'tab1',
      uploadedLists: [],
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    //资源列表
    async getList(page, page_size) {
      this.loadingLists = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.material.lists({
          page: this.page,
          page_size: this.page_size,
          status: 2,
          keyword: this.keyword,
          select_ids: this.select_ids,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loadingLists = false;
    },

    //单条删除
    deleteMedia(row) {
      this.doDeleteMedia([row.id]);
    },

    //批量删除文件
    async batchDeleteMedia() {
      try {
        let ids = this.lists.filter((item) => item.active).map((item) => item.id);
        await this.$confirm('确认删除选中项?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.doDeleteMedia(ids);
      } catch (e) {
        console.error(e);
      }
    },

    //删除多媒体文件
    async doDeleteMedia(material_ids) {
      try {
        await this.api.material.delete({ material_ids });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //切换勾选
    toggleActive(row) {
      if (!row.id && row.status != 1) {
        return;
      }
      this.$set(row, 'active', !row.active);
    },

    //重置勾选项
    resetChecked(row) {
      if (!this.multiple && row.active && this.mode == 1) {
        //非批量 &&  非选中 && 非编辑模式
        this.lists.forEach((item) => {
          if (item.id != row.id) {
            this.$set(item, 'active', false);
          }
        });
      }
    },

    //选择上传文件
    chooseFile() {
      let fileInput = this.$refs.fileInput;
      fileInput.click();
      fileInput.onchange = (e) => {
        let files = e.target.files;
        files = Array.from(files);
        files.forEach((item, index) => {
          //1上传完成 2正在上传 3等待上传 4上传失败
          item.status = 3;
          item.index = this.uploadedLists.length + index;
        });
        if (this.uploadedLists.length + files.length > 100) {
          //超过100
          files.length = 100 - this.uploadedLists.length;
        }
        this.uploadedLists = this.uploadedLists.concat(files);
        this.$forceUpdate();

        this.doUpload(files);
      };
    },

    //上传文件
    async doUpload(files) {
      try {
        await this.utils.upload.uploadFiles(files, {
          bucket: 'vybbasevrv2',
          size: 20,
          opt: {
            persistentOps: 'imageView2/2/w/200/h/100|saveas/',
          },
          onProgress: (res) => {
            let item = this.uploadedLists[res.index];
            let percent = parseInt(res.total.percent);
            item.percent = parseInt(percent) + '%';
            item.status = percent == 100 ? 1 : 2;
            this.$forceUpdate();
          },
          onError: (res) => {
            let item = this.uploadedLists[res.index];
            item.status = 4;
            this.$forceUpdate();
          },
          onSuccess: (res) => {
            let item = this.uploadedLists[res.index];
            item.status = 1;
            item.key = res.key;
            item.preview = res.preview;

            this.$forceUpdate();
          },
          onComplete: () => {
            this.$message.success('上传完毕');
          },
        });
      } catch (e) {
        console.error(e);
      }
      this.$refs.fileInput.value = '';
      this.loadingUpload = false;
    },

    //全选
    changeCheckAll() {
      this.lists.forEach((item) => {
        this.$set(item, 'active', this.checkAll);
      });
    },

    toPreview(url) {
      window.open(url, '_blank');
    },

    //修改资源名称
    async editName(row) {
      try {
        let res = await this.$prompt('修改素材名称', '重命名', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '1-10个字符',
          inputValue: row.name,
          inputPattern: /^[\S]{1,10}$/,
          inputErrorMessage: '长度不正确',
          closeOnClickModal: false,
        });
        this.loading = true;
        await this.api.material.update({
          field_data: { name: res.value },
          id: row.id,
        });
        this.$message.success('修改成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //确认选择
    doSubmit() {
      let selected_lib = this.lists.filter((item) => item.active);
      let selected_upload = this.uploadedLists.filter((item) => item.active);
      if (selected_lib.length == 0 && selected_upload.length == 0) {
        this.$message.error('请先选择图片');
        return;
      }
      this.$emit('change', selected_lib, selected_upload);
      this.$emit('update:show', false);
    },
  },
};
</script>

<style scoped lang="scss">
.preview-lists-box {
  min-height: 100px;
  padding: 0 10px;
  flex: 1;
}

.preview-lists-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.preview-lists {
  display: flex;
  flex-wrap: wrap;
  height: 350px;
  overflow-y: auto;
  align-items: flex-start;
  align-content: flex-start;
}

.preview-item {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  display: inline-block;
  width: 200px;

  &.active {
    background: #eee;
  }

  &.active:before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    border-left: 40px solid transparent;
    border-top: 40px solid #409eff;
    z-index: 3;
  }

  &.active .right {
    color: #fff;
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 4;
    font-size: 12px;
  }

  .preview-box {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
    position: relative;
    overflow: hidden;
  }

  .preview {
    display: block;
    cursor: pointer;
    max-width: 100%;
    max-height: 100%;
  }
}

.preview-footer {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px;
  min-height: 30px;
  box-sizing: border-box;

  .name {
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 10px;
    min-width: 0;
  }

  .category {
    margin-right: 3px;
    flex-shrink: 0;
    font-size: 12px;
    color: #409eff;
  }

  .txt {
    flex: 1;
    min-width: 0;
  }

  .operate {
    display: flex;
    align-items: center;
  }

  .operate-btn {
    color: #666;
  }
}

.placeholder {
  text-align: center;
  line-height: 100px;
}

.upload-btn-box {
  width: 200px;
}

.upload-btn {
  position: relative;
  width: 100%;
  height: 100px;
  line-height: 1;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 10px 0;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-txt {
  color: #999;
  font-size: 12px;
}
</style>
